export default "__VITE_PUBLIC_ASSET__2c8f6f96__"